import { Box, Breadcrumb } from '@chakra-ui/react';
import { FC } from 'react';

export type BreadcrumbItem = {
  label: string;
  path: string;
};

type BreadcrumbNavProps = {
  items: BreadcrumbItem[];
  onNavigate: (path: string) => void;
};

const BreadcrumbNav: FC<BreadcrumbNavProps> = ({ items, onNavigate }) => (
  <Box flex="1" minW="0">
    <Breadcrumb.Root size="sm">
      <Breadcrumb.List gap="1" flexWrap="wrap" alignItems="center">
        {items.flatMap((crumb, index) => {
          const isLast = index === items.length - 1;
          const nodes = [
            (
              <Breadcrumb.Item key={`crumb-${index}`}>
                {isLast ? (
                  <Breadcrumb.CurrentLink>{crumb.label}</Breadcrumb.CurrentLink>
                ) : (
                  <Breadcrumb.Link
                    as="button"
                    type="button"
                    onClick={() => onNavigate(crumb.path)}
                  >
                    {crumb.label}
                  </Breadcrumb.Link>
                )}
              </Breadcrumb.Item>
            ),
          ];
          if (!isLast) {
            nodes.push(<Breadcrumb.Separator key={`sep-${index}`} />);
          }
          return nodes;
        })}
      </Breadcrumb.List>
    </Breadcrumb.Root>
  </Box>
);

export default BreadcrumbNav;
